export var getDescriptionId = function getDescriptionId(fieldId) {
  return "".concat(fieldId, "-description");
};
export var getFeedbackErrorId = function getFeedbackErrorId(fieldId) {
  return "".concat(fieldId, "-feedback-error");
};